import React from 'react';
import { observer } from "mobx-react";
import Highcharts from 'highcharts-more-node'
import HighchartsReact from 'highcharts-react-official'

import { nameFromUrl } from '../lib/strFormatting'
import {countyTableDataStore, hpStateDataStore} from '../store/apiStores'
import {regionCountyDataStore} from '../store/apiStores'
import FigureCaption from '../components/FigureCaption';


export default observer(function USstatePM25InfectionBubblechart(props) {
    let data = []

    let sc = "County PM2.5 vs 7-day COVID rate."
    let lc = "County PM2.5 vs 7-day COVID rate. PM2.5 from monitors in the county. 24-hour mean, max, min shown per selector above. 7-day COVID rate is cases over 7 days per 100K population. Areas towards upper right corner reflect a confluence of higher PM2.5 and higher COVID rate."
    if (props.state && countyTableDataStore.data) {
        data = countyTableDataStore.data.map((e) => {
            return {
                x: e.confirmed_last_7_per_100k,
                y: e[props.pm25Field],
                z: e.population,
                name: e.county
            }
        })
    } else if (props.region && regionCountyDataStore.data) {

        if (props.region == "United States") {
            data = regionCountyDataStore.data.filter((e) => {return e.county[0] == "("})
            sc = "State PM2.5 vs 7-day COVID rate."
            lc = "State PM2.5 vs 7-day COVID rate. PM2.5 from monitors in the state. 24-hour mean, max, min shown per selector above. 7-day COVID rate is cases over 7 days per 100K population. Areas towards upper right corner reflect a confluence of higher PM2.5 and higher COVID rate."
        } else {
            data = regionCountyDataStore.data.filter((e) => {return e.county[0] != "("})
        }

        data = data.map((e) => {
            return {
                x: e.confirmed_last_7_per_100k,
                y: e[props.pm25Field],
                z: e.population,
                name: e.county_state
            }
        })
    } else if (hpStateDataStore.data) {
        data = hpStateDataStore.data.map((e) => {
            return {
                x: e.confirmed_last_7_per_100k,
                y: e[props.pm25Field],
                z: e.population,
                name: e.state
            }
        })
    }

    data.forEach((e) => {
        e.xStr = (e.x) ? (e.x.toLocaleString()) : ('n/a')
        e.yStr = (e.y) ? (e.y.toLocaleString()) : ('n/a')
        e.zStr = (e.z) ? (e.z.toLocaleString()) : ('n/a')
    })

    const labels = {
        mean_pm25: 'Mean',
        max_pm25: 'Max',
        max_3hr_pm25_avg: "3hr Max",
        min_pm25: 'Min'
    }

    let maxX = Math.max(...data.map(function(o) {
        if(o.y != null){
            return o.x;
        }
        else {
            return null;
        }
    }))

    let subtitle = 'per state'
    if (props.state) {
        subtitle = `${nameFromUrl(props.state)} State per county`

    } else if (props.region) {
        subtitle = `${nameFromUrl(props.region)} Region per county`
    }

    let options = {
            chart: {
                type: 'bubble',
                plotBorderWidth: 1,
                zoomType: 'xy'
            },

            legend: {
                enabled: false
            },

            title: {
                text: 'PM2.5 Levels & 7 Day Rate of Infection',
                align: 'left'
            },

            subtitle: {
                text: subtitle,
                align: 'left'
            },

            accessibility: {
                point: {
                    valueDescriptionFormat: '{index}. {point.name}, infection rate: {point.x} (7-day cases/100k), PM2.5 Level: {point.y} ug/m3, population: {point.z}.'
                }
            },

            xAxis: {
                gridLineWidth: 1,
                max: maxX,
                title: {
                    text: '7 Day Rate of Infection (7 day cases/100k)'
                },
                labels: {
                    format: '{value}'
                },
                accessibility: {
                    rangeDescription: 'COVID-19 Rate of Infection'
                }
            },

            yAxis: {
                startOnTick: false,
                endOnTick: false,
                title: {
                    text: `Recent PM2.5 - 24HR Ave - ${labels[props.pm25Field]}`
                },
                labels: {
                    format: '{value} ug/m3'
                },
                maxPadding: 0.2,
                plotLines: [{
                    color: 'black',
                    dashStyle: 'dot',
                    width: 2,
                    value: 12,
                    label: {
                        align: 'right',
                        style: {
                            fontStyle: 'italic'
                        },
                        text: 'Safe PM2.5 level',
                        x: -10
                    },
                    zIndex: 3
                }],
                plotBands: [{ // Good
                    from: 0.0,
                    to: 9.09,
                    color: 'rgba(46, 204, 112, 0.3)',
                }, { // Moderate
                    from: 9.1,
                    to: 35.49,
                    color: 'rgba(241, 196, 14, 0.2)',
                }, { // Unhealthy for Sensitive Groups
                    from: 35.5,
                    to: 55.49,
                    color: 'rgba(230, 126, 34, 0.3)',
                }, { // Unhealthy
                    from: 55.5,
                    to: 125.49,
                    color: 'rgba(231, 76, 60, 0.3)',
                }, { // Very Unhealthy
                    from: 125.5,
                    to: 225.49,
                    color: 'rgba(209, 157, 215, 0.3)',
                }, { // Hazardous
                    from: 225.5,
                    to: Infinity,
                    color: 'rgba(140, 58, 58, 0.4)',
                }],
                accessibility: {
                    rangeDescription: 'Average PM2.5 Levels'
                }
            },

            tooltip: {
                useHTML: true,
                headerFormat: '<table>',
                pointFormat: '<tr><th colspan="2"><h3>{point.name}</h3></th></tr>' +
                    '<tr><th>7 Day Infection Rate:</th><td>{point.xStr} 7-day cases/100k</td></tr>' +
                    `<tr><th>${labels[props.pm25Field]} PM2.5:</th><td>{point.yStr} ug/m3</td></tr>` +
                    '<tr><th>Population:</th><td>{point.zStr}</td></tr>',
                footerFormat: '</table>',
                followPointer: true
            },

            plotOptions: {
                series: {
                    dataLabels: {
                        enabled: true,
                        format: '{point.name}'
                    }
                }
            },

            series: [{
                data: data
            }]

        }

    return (
         <div>
            <HighchartsReact
                highcharts={Highcharts}
                options={options} />
            <FigureCaption short_caption={sc} caption={lc} />
            <br />
        </div>
    )
})
